import { Language } from '../interfaces/language.interface';

export const LANGUAGES: readonly Language[] = [
  { code: 'pt-BR', name: 'Português', flag: '🇧🇷' },
  { code: 'en-US', name: 'English',   flag: '🇺🇸' },
  { code: 'es-ES', name: 'Español',   flag: '🇪🇸' },
];
